const env = import.meta.env;
const is_prod = env.VITE_APP_ENV == 'production';

export const APP_ENV = env.VITE_APP_ENV;
export const APP_URL = env.VITE_APP_URL || window.location.origin;
export const TURNSTILE_SITE_KEY = env.VITE_TURNSTILE_SITE_KEY;
export const SENTRY_VUE_DSN = env.VITE_SENTRY_VUE_DSN; 
export const FRILL_KEY = env.VITE_FRILL_KEY;
export const SLACK_CLIENT_ID = env.VITE_SLACK_CLIENT_ID;

export const TRIAL_DAYS = 10;
// Disable CAPTCHA in non-production by default; allow explicit override via VITE_DISABLE_CAPTCHA=true
export const DISABLE_CAPTCHA = (env.VITE_DISABLE_CAPTCHA === 'true') || (env.VITE_APP_ENV !== 'production');
export const SENTRY_TRACES_SAMPLE_RATE = 0.5; 
// export const UNLOCK_PROGRAM_COUPON_CODE = ""; 
// export const UNLOCK_PROGRAM_SOURCE_PLAN_ID = is_prod ? env.VITE_UNLOCK_PROGRAM_SOURCE_PLAN_ID : page.vite.unlock_program_source_plan_id; 
export const UNLOCK_PROGRAM_IMAGE = "/images/unlock-program/discount.svg";
export const UNLOCK_PROGRAM_TEXT_BEFORE = "Unlock 40% Discount For the first year";
export const UNLOCK_PROGRAM_TEXT_AFTER = "You have Unlocked a 40% Discount for all Yearly Plans.";
export const IS_STORE_ACTIVE = true;
export const CARD_VERIFICATION_ENABLED = false;
export const TRIAL_PROGRAM_DAYS = [30, 15];
export const CUSTOM_NAV_LOGO = "https://chemicloud.com/templates/lagom2/assets/img/logo/logo_big_inverse.svg";
export const USERMAVEN_ENABLED = is_prod;
export const USERMAVEN_API_KEY = env.VITE_USERMAVEN_API_KEY;
export const USERMAVEN_SERVER_TOKEN = env.VITE_USERMAVEN_SERVER_TOKEN;
export const USERMAVEN_SRC_DOMAIN = "t.usermaven.com";
export const USERMAVEN_TRACKING_HOST = "events.usermaven.com";
export const API_SERVER_URL = is_prod ? "https://api.instawp.io" : env.VITE_API_SERVER_URL ?? "https://stage-api.instawp.io";
export const INSTAWP_LIVE_ADDON_ACTIVATE = 1;
export const DEFAULT_SUFFIX_DOMAIN_ID = 1;
export const GALLERY_IMAGE_SIZE = 2048;
export const MIGRATION_SUPPORT_FORM_URL = "https://instawp.to/migration-form";
export const ATARIM_APP_URL = is_prod ? "https://app.atarim.io/fetching" : "https://appv1.wpfeedback.co/fetching";
export const PPU_CARD_ADD_CREDITS = 25;
// export const ATARIM_API_URL = is_prod ? "https://api.atarim.io/fetch_api_key" : "https://apiv1.wpfeedback.co/fetch_api_key";


